import AuxTest from './AuxTest';
export default {
  install(molten) {
    // simple test
    // molten.addPlugin( 'GroupDataViewer', {
    //   type : 'test',
    //   name : 'Test Viewer',
    //   icon : 'fa fa-star fa-fw',
    //   location : 'main',
    //   handles : ( ) => true,
    //   component : Test
    // } )

    // // simple test
    // molten.addPlugin( 'GroupDataViewer', {
    //   type : 'test2',
    //   name : 'Another Test Viewer',
    //   icon : 'fa fa-paw fa-fw',
    //   location : 'main',
    //   handles : ( ) => true,
    //   component : Test
    // } )

    // // simple test
    // molten.addPlugin( 'GroupDataViewer', {
    //   type : 'test3',
    //   name : 'Shuttle Test Viewer',
    //   icon : 'fa fa-space-shuttle fa-fw',
    //   location : 'main',
    //   handles : ( ) => true,
    //   component : Test2
    // } )

    // simple test
    molten.addPlugin('GroupDataViewer', {
      type: 'stats1',
      name: 'Stats',
      icon: 'fa fa-shower fa-fw',
      location: 'aux',
      handles: () => true,
      component: AuxTest
    });

    // simple test
    // molten.addPlugin( 'GroupDataViewer', {
    //   type : 'stats2',
    //   name : 'More Stats',
    //   icon : 'fa fa-wrench fa-fw',
    //   location : 'any',
    //   handles : ( ) => true,
    //   component : AuxTest,
    //   props : { showMore : true }
    // } )
  }
};